import React from 'react'
import { ChartContainer } from './styles'
import { Bar } from 'react-chartjs-2'

function AvgPersistenceChart({xData, customer, group}) {

    const data = {
      labels: xData,
      datasets: [
        {
          label: 'Persistence Points',
          data: customer,
          backgroundColor: 'rgb(230, 150, 233)',
        },
        {
          label: 'Group Avg',
          data: group,
          backgroundColor: 'rgb(174, 128, 236)',
        }
      ],
    }
    
    const options = {
      maintainAspectRatio: false,
      scales: {
        xAxes: [ {
          scaleLabel: {
            display: true,
            labelString: 'Period (2 weeks)'
          } 
        } ],
      }
    }

    return(
          <ChartContainer className="chart-container">
              <Bar data={data} options={options}/>
          </ChartContainer>
    )
}

export default AvgPersistenceChart